import React from "react";
import { Link } from "react-router-dom";
import { MapPin, CalendarDays, Clock, ExternalLink } from "lucide-react";

export default function PromotionCard({ promo, index = 0 }) {
  const img = promo.images?.[0];
  return (
    <article data-testid={`promo-card-${promo.id}`} className="card-luxe overflow-hidden flex flex-col">
      <Link to={`/promotions/${promo.id}`} data-testid={`promo-image-link-${promo.id}`} className="block relative h-56 overflow-hidden group">
        {img ? (
          <img
            src={img.url}
            alt={img.alt || promo.title}
            loading="lazy"
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            style={{ objectPosition: `${img.focal?.x ?? 50}% ${img.focal?.y ?? 50}%` }}
          />
        ) : (
          <div className="w-full h-full bg-[#0B1D3A] flex items-center justify-center text-amber-300 font-heading text-2xl">LD Travel</div>
        )}
        {promo.featured && (
          <span className="absolute top-4 left-4 bg-[#D4AF37] text-[#0B1D3A] text-[11px] font-bold uppercase tracking-widest px-3 py-1.5 rounded-full">Featured</span>
        )}
      </Link>
      <div className="p-6 flex flex-col flex-1">
        <h3 className="font-heading text-2xl text-[#0B1D3A] font-semibold leading-snug">{promo.title}</h3>
        {promo.destination && (
          <p className="flex items-center gap-1.5 text-sm text-slate-500 mt-2">
            <MapPin className="w-4 h-4 text-amber-600" aria-hidden="true" /> {promo.destination}
          </p>
        )}
        {promo.price && (
          <p className="mt-3 text-[#0B1D3A]">
            <span className="text-xs uppercase tracking-widest text-slate-500 block">{promo.price_label || "Starting at"}</span>
            <span className="font-heading text-3xl font-semibold text-amber-700">{promo.price}</span>
          </p>
        )}
        <div className="mt-3 space-y-1 text-xs text-slate-500">
          {promo.travel_dates && <p className="flex items-center gap-1.5"><CalendarDays className="w-3.5 h-3.5" aria-hidden="true" /> {promo.travel_dates}</p>}
          {promo.booking_deadline && <p className="flex items-center gap-1.5"><Clock className="w-3.5 h-3.5" aria-hidden="true" /> Book by {promo.booking_deadline}</p>}
        </div>
        <div className="mt-auto pt-5 flex flex-wrap gap-3">
          <a
            href={promo.button_url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`promo-book-button-${promo.id}`}
            className="btn-brand !py-2.5 !px-5 text-sm"
          >
            {promo.button_text || "View Offer / Book"} <ExternalLink className="w-3.5 h-3.5" aria-hidden="true" />
            <span className="sr-only">(opens an external website in a new tab)</span>
          </a>
          <Link to={`/promotions/${promo.id}`} data-testid={`promo-details-link-${promo.id}`} className="btn-outline !py-2.5 !px-5 text-sm !text-[#0B1D3A]">
            Details
          </Link>
        </div>
      </div>
    </article>
  );
}
